<template>
	<input v-if="visible" type="time" v-model="value" :style="style" :class="[clazz, errorClass]" :readonly="ro" v-bind="attrs">
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "@fd/editors/Editor.ts";
import {injectEnv} from "@fd/Environment.ts";
import {computed} from "vue";
import {Time} from "@t/fd/editor/Time.ts";

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;
const env = injectEnv();

const time = computed<Time>(() => props.part as Time);
const {visible, value, clazz, style, ro, errorMessage, errorClass, tabindexBinding} = useEditor(props);

const attrs = computed(() => {
	const a: any = tabindexBinding();
	const errMsg = errorMessage.value;
	if (errMsg) a.title = errMsg;	// if error put as title
	return a;
});

</script>

<style>

</style>